export const DEFAULT_BROADCAST_CHANNEL_KEY = 'broadcast_default';

const defaultBroadcastService = window?.BroadcastChannel ? new BroadcastChannel(DEFAULT_BROADCAST_CHANNEL_KEY) : undefined;

export {
  defaultBroadcastService as defaultBroadcastServiceReceiver,
  defaultBroadcastService as defaultBroadcastServiceSender,
};
